export const lookupKeys = {
  client: {
    root: ['clients', 'lookup'] as const,
    byIds: (ids?: number[], includeSites?: boolean) =>
      ['clients', 'lookup', ids, includeSites] as const,
  },
  site: {
    root: ['sites', 'lookup'] as const,
    byClient: (clientId?: number) => ['sites', 'lookup', clientId] as const,
    all: ['sites', 'lookup', 'all'] as const,
    byIds: (ids: number[]) => ['sites', 'lookup', 'ids', ids] as const,
  },
  employee: {
    root: ['employees', 'lookup'] as const,
    single: (id: number) => ['employees', 'lookup', id] as const,
    batch: (ids: number[]) => ['employees', 'lookup', 'batch', ids] as const,
    backoffice: ['employees', 'lookup', 'backoffice'] as const,
  },
  guard: {
    list: ['employees', 'lookup', 'guards'] as const,
    byClient: (clientId?: number) => ['employees', 'lookup', 'guards', 'byClient', clientId] as const,
    withEnded: (clientId?: number) => ['employees', 'lookup', 'guards', 'withEnded', clientId] as const,
    // Sorted so the same set of ids in a different order (e.g. after a draft
    // change reorders the week's guard set) hits the same cached query
    // instead of refetching and flashing every card back to a placeholder.
    batch: (ids: number[]) => ['employees', 'lookup', 'guards', 'batch', [...ids].sort((a, b) => a - b)] as const,
  },
  department: {
    root: ['departments'] as const,
    list: (params: Record<string, unknown> = {}) => ['departments', params] as const,
  },
  employmentCategory: {
    root: ['employment-categories'] as const,
    list: (params: Record<string, unknown> = {}) => ['employment-categories', params] as const,
  },
  shiftCategory: {
    root: ['shift-categories'] as const,
  },
  permission: {
    root: ['access-profiles', 'permissions'] as const,
    list: (filters?: unknown) => ['access-profiles', 'permissions', filters] as const,
  },
} as const
